<template>
  <div>
    <div style="border: 1px solid #aaa; padding: 10px 10px; margin-top: 30px">
      波次校验设置
    </div>
    <div style="border: 1px solid #aaa; border-top: 0; padding: 20px">
      <el-form>
        <el-form-item label="波次校验必须称重: " class="open-weight">
          <el-switch
            v-model="form.open_weight"
            active-value="1"
            inactive-value="2"
          >
          </el-switch>
          <div class="express-node-wrap">
            <span class="express-node-label"
              >波次锁定时系统提前根据预测包裹重量分配快递:</span
            >
            <el-switch
              v-model="form.set_express_node"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="称重差异容错比例: ">
          「称重重量」与「计算重量」的差异超过±
          <ys-input
            v-model="form.weight_rate"
            style="width: 90px"
            pattern="positiveInt"
            min="1"
            max="100"
            :disabled="form.open_weight === OPEN_WEIGHT_STATUS.CLOSED"
          >
          </ys-input>
          %，就提示重新称重。
          <div style="color: gray">
            （举例：包裹计算重量为1000克，设置为±30%，称重重量小于700克或大于1300克的时候就会报错）
          </div>
        </el-form-item>
        <el-form-item label="是否开启差异出库: ">
          <el-switch v-model="form.is_open" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="差异出库容错比例: ">
          低于等于
          <el-input
            v-model="form.rate"
            style="width: 120px"
            :disabled="!Number(form.is_open)"
          ></el-input>
          （填写小数即可，如0.02即为2%，即100件允许有2件误差）
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
const OPEN_WEIGHT_STATUS = {
  OPEN: "1",
  CLOSED: "2",
};
export default {
  data() {
    return {
      OPEN_WEIGHT_STATUS,
      form: {
        is_open: false,
        rate: 0,
        open_weight: OPEN_WEIGHT_STATUS.CLOSED,
        weight_rate: 0,
      },
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    submit() {
      if (this.form.rate > 1) {
        this.$message.error("容错比例不能超过1");
        return;
      }
      if (this.form.rate < 0) {
        this.$message.error("容错比例不能小于0");
        return;
      }
      if (!/(?:^0\.\d{1,2}$)|^1$/.test(this.form.rate)) {
        this.$message.error("格式不正确, 请输入[0.XX]或者[1]");
        return;
      }

      this.$http
        .post("/erp/WavePicking/diffStockoutSettingSave", {
          value: this.form,
        })
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.error(rs.data.msg);
          } else {
            this.$message.success("保存成功");
          }
        });
    },
    fetchData() {
      this.$http
        .post("/erp/WavePicking/diffStockoutSettingGet")
        .then((rs) => {
          this.form = rs.data.data;
        })
        .catch((_) => {
          this.$message.error("获取配置失败, 请刷新页面或者联系技术人员");
        });
    },
  },
};
</script>

<style scoped>
.express-node-wrap {
  display: inline-block;
  margin-left: 24px;
  line-height: 1;
}
.express-node-label {
  margin-right: 12px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WaveCheckSetting.vue